import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap } from 'rxjs/operators';
import { Action } from 'redux';
import {
  AttachToRecordLabel,
  CreateRecordLabelSuccess,
} from '../action-creators';
import {
  CREATE_RECORD_LABEL_SUCCESS,
} from '../actions';

export const attachArtistAfterCreateRosterEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, CreateRecordLabelSuccess>(CREATE_RECORD_LABEL_SUCCESS),
    concatMap((action) => {
      return action.artistsToAttach.map((artist) => {
        const NewRecordLabelRelationship = {
          recordLabelId: action.recordLabel.id,
          recordLabelName: action.recordLabel.name || action.rosterName,
          artistId: artist.id,
          artistName: artist.name,
          artistAvatar: artist.avatar,
        };

        return new AttachToRecordLabel(NewRecordLabelRelationship);
      });
    })
  );
